module.exports = __webpack_public_path__ + "img/keycap:-10.f9bc28ff.png";